<template>
  <div class="payment-status">
    <div v-if="isLoading"
      class="loader-wrapper">
      <div class="loader"></div>
      <span>Sprawdzam status płatności. Proszę czekać..</span>
    </div>
    <div class="status-wrapper" v-else>
      <div v-if="status == 'success'">
        <img :src="require('@/assets/images/success.svg')" />
        <span>Płatność została pomyślnie zatwierdzona.</span>
      </div>

      <div v-else>
        <img :src="require('@/assets/images/errorIcon.svg')" />
        <span>Płatność została odrzucona.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getPaymentService } from '@/services/paymentService'
import { getAndroidContext } from '@/services/sessionProps'

export default {
  name: 'PaymentStatus',
  data () {
    return {
      status: '',
      paymentId: '',
      isLoading: true,
      timeout: null
    }
  },
  mounted () {
    if(!getAndroidContext().isAndroidContext()) {
      this.$router.push({name: 'tab3'})
    }

    this.paymentId = this.$route.query.internalPaymentId

    this.checkStatus()
  },
  methods: {
    async checkStatus() {
      const payments = await getPaymentService().checkPaymentStatus(this.paymentId)

      if(payments.length > 0) {
        if(payments[0].status === 'REFUNDED') {
          this.isLoading = false
          this.status = 'success'
          clearTimeout(this.timeout)
        } else if(payments[0].status === 'CANCELLED') {
          this.isLoading = false
          this.status = 'failure'
          clearTimeout(this.timeout)
        } else {
          this.timeout = setTimeout(this.checkStatus, 2000)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.payment-status {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loader-wrapper {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}

.status-wrapper {
  img {
    display: block;
    margin: auto;
    margin-bottom: 2rem;
  }
}

.loader {
  width: 20px;
  margin: 1px;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.5em solid $primary;
  border-right: 0.5em solid $primary;
  border-bottom: 0.5em solid $primary;
  border-left: 0.5em solid #ffffff;
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 0.8s infinite linear;
  margin-bottom: 2rem;
}

.loader,
.loader:after {
  border-radius: 100%;
  width: 3em;
  height: 3em;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>